import { FilterFamily } from 'types/generated/graphql';

const familyToOverwriteLabel = ['vocals', 'fx'];

/**
 * Creates a map of all filter codes to their family codes
 * @param instruments Array of instrument families
 * @returns A map where keys are filter codes and values are their family codes
 * @note We have to define family we want to map in familyToOverwriteLabel
 * @example
 * const map = createFilterFamilyMap(instruments);
 * console.log(map['rap']); // 'vocals'
 */
export const createFilterFamilyMap = (
    filterFamilies?: FilterFamily[],
): Record<string, string> => {
    const map: Record<string, string> = {};

    // Helper function to add filters to the map
    const addFiltersToMap = (filters?: FilterFamily[]) => {
        if (!filters) return;

        filters.forEach((family) => {
            const isOverwriteLabel = familyToOverwriteLabel.includes(
                family.code,
            );

            if (!isOverwriteLabel || !family.subFilters) return;

            family.subFilters.forEach((subFilter) => {
                if (subFilter.code) {
                    map[subFilter.code] = family.code;
                }
            });
        });
    };

    // Add all filter types to the map
    addFiltersToMap(filterFamilies);

    return map;
};
